import { render } from "./BigPictureBannerPurple.vue?vue&type=template&id=49295c4a&scoped=true"
import script from "./BigPictureBannerPurple.vue?vue&type=script&lang=js"
export * from "./BigPictureBannerPurple.vue?vue&type=script&lang=js"

import "./BigPictureBannerPurple.vue?vue&type=style&index=0&id=49295c4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49295c4a"]])

export default __exports__